import React from "react";
import style from "./EventDetailsSpeakers.module.css";
import Image from "next/image";

interface ImageData {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface TitleDescription {
  id: number;
  title: string;
  description: string;
}

interface Speaker {
  id: number;
  title_description: TitleDescription;
  images: ImageData[];
}

interface EventDetailsSpeakersProps {
  data: {
    title: string;
    cards: Speaker[];
  };
}

const EventDetailsSpeakers: React.FC<EventDetailsSpeakersProps> = ({
  data,
}) => {
  return (
    <div className={style.detailSpeakers}>
      <div className="container">
        <h2>{data.title}</h2>
        <div className={style.speakerDetails}>
        {data.cards.map((item) => (
          <div className={style.speakerList} key={item.id}>
              {item.images.length > 0 && (
                <Image
                  src={item.images[0].url}
                  width={220}
                  height={220}
                  alt={item.title_description.title}
                  className="rounded-circle mb-3"
                />
                            )}
              <h5>{item.title_description.title}</h5>
              <span>{item.title_description.description}</span>
            </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default EventDetailsSpeakers;
